import React from "react";
import JoinImg from "../../../../assets/affiliates/join.png";
import GetInTouch2 from "../../../../assets/get_in_touch2.png";
import Arrow from "../../../../assets/icons/arrow.svg";
import { useTranslation } from "react-i18next";
import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { useAuth } from "../../../../hooks/useAuth";
import { useAffiliateNavigation } from "../../hooks/useAffiliateNavigation";
import { useUserProfile } from "../../../../hooks/useUserProfile";

export const JoinSentomReClubSection = () => {
  const { t, i18n } = useTranslation(["affiliates"]);
  const isRTL = i18n.dir() === "rtl";
  const langTheme = useLanguageTheme();

  const isAuthenticated = useAuth();
  const { handleAffiliateNavigation } = useAffiliateNavigation();
  const { profile }: { profile: any } = useUserProfile();

  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
  const downXl = useMediaQuery((theme: Theme) => theme.breakpoints.down("xl"));
  const downLg = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  return (
    <div
      className="join-sentom-wrapper"
      style={{
        paddingTop: downMd ? "38px" : "50px",
      }}
    >
      <div
        style={{
          marginRight: "20px",
          marginLeft: "20px",
          display: "flex",
          gap: downXl ? "35px" : "50px",
          flexDirection: downLg ? "column-reverse" : "row",
          justifyContent: "center",
          paddingBottom: downMd ? "40px" : "105px",
          borderBottom: "1px solid rgba(0, 0, 0, 0.09)",
          maxWidth: "1500px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: isRTL ? "flex-end" : "flex-start",
            width: downLg ? "100%" : "auto",
            gap: downLg ? "10px" : "15px",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "70%",
              maxWidth: downXl ? "500px" : "444px",
              paddingLeft: downMd ? "11px" : "20px",
            }}
          >
            <div
              style={{
                position: "relative",
                zIndex: 3,
                width: "100%",
              }}
            >
              <img
                src={JoinImg}
                style={{
                  position: "relative",
                  width: "100%",
                  zIndex: 3,
                }}
              />
              <div
                style={{
                  backgroundColor: "rgba(215, 161, 72, 1)",
                  width: "164px",
                  height: "146px",
                  position: "absolute",
                  bottom: downMd ? "-11px" : "-20px",
                  zIndex: 1,
                  left: downMd ? "-11px" : "-20px",
                }}
              ></div>
            </div>
          </div>
          <div
            style={{
              width: "30%",
              maxWidth: downLg ? "300px" : downXl ? "160px" : "190px",
            }}
          >
            <img
              src={GetInTouch2}
              style={{
                marginTop: downLg ? "0" : "44px",
                width: "100%",
              }}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: isRTL ? "flex-end" : "flex-start",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontFamily: langTheme.mainFont(),
              color: "rgba(252, 188, 92, 1)",
              mb: downMd ? "9px" : "5px",
              fontWeight: 600,
              lineHeight: downMd ? "16px" : "18px",
            }}
          >
            {t("join_sentom_second_titlte")}
          </Typography>
          <Typography
            sx={{
              fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
              textTransform: "uppercase",
              mb: downMd ? "15px" : "25px",
              color: "rgba(0, 0, 0, 1)",
              maxWidth: "444px",
              textAlign: isRTL ? "end" : "start",
              fontSize: downMd ? "24px" : "34px",
              fontWeight: 600,
              lineHeight: downMd ? "28px" : "40px",
            }}
          >
            {t("join_sentom_main_titlte")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              color: "#fff",
              width: "fit-content",
              backgroundColor: "rgba(3, 74, 115, 1)",
              p: "15px 30px 15px 30px",
              cursor: "pointer",
              borderRadius: "24px",
              direction: i18n.dir(),
              gap: "10px",
              "&:hover": {
                background: "linear-gradient(to right, #034A73, #0A7992)",
              },
            }}
            onClick={() => handleAffiliateNavigation(isAuthenticated, profile)}
          >
            <Typography
              sx={{
                mr: isRTL ? "0" : "12px",
                ml: isRTL ? "12px" : "0",
                fontWeight: isRTL ? 600 : 500,
                fontFamily: langTheme.mainFont(),
                lineHeight: "16px",
              }}
            >
              {t("register_now")}
            </Typography>
            <img
              src={Arrow}
              alt="arrow"
              style={{
                transform: isRTL ? "scaleX(-1)" : " scaleX(1)",
              }}
            />
          </Box>
        </div>
      </div>
    </div>
  );
};
